import { VStack } from '@ui-furniture/elements';
import { Form as BaseForm } from '@ui-furniture/lib/form';

export const Form: typeof BaseForm = ({ children, ...rest }) => (
  <BaseForm {...rest}>
    <VStack spacing='lg'>{children}</VStack>
  </BaseForm>
);
